import { render, staticRenderFns } from "./AiClients.vue?vue&type=template&id=45f190f9&scoped=true"
import script from "./AiClients.vue?vue&type=script&lang=js"
export * from "./AiClients.vue?vue&type=script&lang=js"
import style0 from "./AiClients.vue?vue&type=style&index=0&id=45f190f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f190f9",
  null
  
)

export default component.exports